import { get } from "lodash";
import moment from "moment";
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import patientType from "~/store/patient/patientType";
import * as types from "~/store/patientForm/patientFormType";
import { huyi } from "~/utils/clog";
import { handleAge } from "~/utils/constants";
import { client } from "~/utils/medproSDK";
import { handleUnAuthorize } from "~/utils/unAuthorize";
import { getPatientList } from "../patient/patientAction";
import { offLoading, onLoading } from "../totalData/actions";
import { logOutWithoutNoti } from "../user/userAction";

function* requestCreatePatientInForm({ force }) {
  try {
    const { info: patientInfo } = yield select(state => state.patientForm);
    const { urlRedirectAfterCreatePatient } = yield select(
      state => state.patientForm
    );
    const partnerid = yield select(state => state.totalData.partnerId);

    const keys = Object.keys(patientInfo);
    const postData = {};
    keys.map(key => {
      postData[key] = patientInfo[key].value;
      return "";
    });

    const getFullname = postData.fullname.split(" ");
    postData.surname = getFullname.slice(0, -1).join(" ");
    postData.name = getFullname.slice(-1).join(" ");

    postData.birthdate = moment(
      `${postData.birthyear}-${postData.birthmonth}-${postData.birthday}`,
      "YYYY-MM-DD"
    )
      .utc(true)
      .toISOString();

    postData.force = force;

    const yearOld = moment().diff(postData.birthdate, "years", true);

    if (yearOld < handleAge(partnerid)) {
      postData.mobile = postData.relative_mobile;
    }

    if (!postData.mobile) {
      postData.mobile = postData.relative_mobile;
    }

    delete postData.birthmonth;
    delete postData.birthday;

    const token = yield select(state => state.user.info.token);

    const response = yield client.insertPatient(
      { ...postData },
      {
        partnerid: partnerid || "medpro",
        token,
        platform: "pc"
      }
    );

    const { data } = response;
    if (data.isRecommended) {
      yield put({
        type: types.CHECK_PATIENT_BEFORE_CREATE,
        newPatient: data.patientForm,
        listOldPatient: data.recommendedPatientList
      });
      openToast(data.message, "error");
      history.push("/check-patient-before-create");
    } else {
      if (typeof data.error_code === typeof undefined) {
        yield put({
          type: patientType.SELECTED_PATIENT_AFTER_CREATE,
          selectedPatient: data
        });
        yield put({
          type: types.CREATE_PATIENT_FORM_SUCCESS,
          info: data
        });
        openToast("Tạo mới hồ sơ thành công.");
      }
      history.push(urlRedirectAfterCreatePatient);
    }
  } catch (error) {
    huyi({
      name: "error-requestCreatePatientInForm",
      child: error,
      type: 0
    });

    const errorCMND = get(
      error,
      "response.data.message[0].constraints.isNumberString",
      false
    );
    const errMobile = get(
      error,
      "response.data.message[0].constraints.isMobilePhone",
      false
    );
    const errorCMND2 = get(
      error,
      "response.data.message[0].constraints.CheckCMND",
      false
    );

    if (error.response.data.message) {
      openToast(error.response.data.message, "error");
    }

    const trungHoSo = get(error, "response.data.message", false);
    if (error.response.data.statusCode === 400) {
      if (errMobile) openToast(errMobile, "error");
      if (errorCMND) openToast(errorCMND, "error");
      if (errorCMND2) openToast(errorCMND2, "error");
    }
    if (error.response.data.statusCode === 401) {
      yield put(logOutWithoutNoti());
      handleUnAuthorize();
    }
    if (error.response.data.statusCode === 409) {
      if (trungHoSo) openToast(trungHoSo, "error");
    }

    yield put({
      type: types.CREATE_PATIENT_FORM_FAILURE,
      error
    });
  }
}

function* watchRequestCreatePatientForm() {
  yield takeLatest(
    types.CREATE_PATIENT_FORM_REQUEST,
    requestCreatePatientInForm
  );
}

function* getPatientDetailWorker({ id }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    yield put(onLoading());

    const token = yield select(state => state.user.info.token);
    const response = yield client.getPatientInfoToUpdate(
      { id },
      { token, platform }
    );

    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: types.DETAIL_PATIENT_FORM_SUCCESS,
      info: {
        ...response.data
      }
    });
    yield put({
      type: patientType.SELECTED_PATIENT_DETAIL,
      value: response.data
    });
    yield put(offLoading());
  } catch (error) {
    huyi({ name: "client.getPatientInfoToUpdate", child: error, type: 0 });
    yield put({
      type: types.DETAIL_PATIENT_FORM_FAILURE,
      error
    });
  }
}

function* updatePatientlWorker() {
  try {
    yield put(onLoading());
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const { info: patientInfo } = yield select(state => state.patientForm);
    const { phoneNumberVerify } = yield select(state => state.patient);
    const keys = Object.keys(patientInfo);

    const partnerid = yield select(state => state.totalData.partnerId);

    const postData = {};
    keys.map(key => {
      postData[key] = patientInfo[key].value;
      return "";
    });

    const getFullname = postData.fullname.split(" ");
    postData.surname = getFullname.slice(0, -1).join(" ");
    postData.name = getFullname.slice(-1).join(" ");
    postData.relative_name = postData.relative_name.toUpperCase();

    if (postData?.mobile?.includes("xx")) {
      postData.mobile = phoneNumberVerify;
    }

    const currentYear = Number(moment().format("YYYY"));
    const yearOld = currentYear - postData.birthyear;

    if (!postData.mobile && yearOld < 18) {
      postData.mobile = postData.relative_mobile;
    }

    postData.birthdate = moment(
      `${postData.birthyear}-${postData.birthmonth}-${postData.birthday}`,
      "YYYY-MM-DD"
    )
      .utc(true)
      .toISOString();

    const token = yield select(state => state.user.info.token);

    const response = yield client.updatePatient(postData, {
      partnerid,
      token,
      platform
    });

    yield put({
      type: types.UPDATE_PATIENT_FORM_SUCCESS,
      info: response.data
    });

    yield put(getPatientList());
    yield put(offLoading());

    window.history.go(-1);
    openToast("Cập nhật thành công!");
  } catch (error) {
    yield put(offLoading());

    huyi({ name: "error-updatePatientlWorker", child: error, type: 0 });

    const statusCode = get(error, "response.data.statusCode", 0);
    const errorCMND = get(
      error,
      "response.data.message[0].constraints.isNumberString",
      false
    );
    const errorCMND2 = get(
      error,
      "response.data.message[0].constraints.CheckCMND",
      false
    );

    if (statusCode === 400) {
      if (errorCMND) openToast(errorCMND, "error");
      else if (errorCMND2) openToast(errorCMND2, "error");
      else {
        const message = get(error, "response.data.message", "");
        openToast(message, "error");
      }
    } else if (statusCode === 401) {
      window.localStorage.removeItem("jwt");
      yield put(logOutWithoutNoti());
    } else {
      const message = get(error, "response.data.message", "");
      openToast(message, "error");
    }

    yield put({
      type: types.UPDATE_PATIENT_FORM_FAILURE,
      error
    });
  }
}

function* watchPatient() {
  yield all([
    takeLatest(types.DETAIL_PATIENT_FORM_REQUEST, getPatientDetailWorker),
    takeLatest(types.UPDATE_PATIENT_FORM_REQUEST, updatePatientlWorker)
  ]);
}

export default function* root() {
  yield all([fork(watchRequestCreatePatientForm), fork(watchPatient)]);
}
